// @flow
import type { ID } from '../core/types'
import type { Address } from './myProfile/types'
import type { Auction } from './auction/types'
import { MEDIA_URL } from '../config'
import { domains } from '.'

export const getFullAddress = ({
  name,
  street1,
  street2,
  zipCode,
  city,
  state,
  country,
  phone
}: Address): string =>
  `${name || ''}\n${street1 || ''}\n${street2 || ''}\n${city || ''} ${zipCode ||
    ''}\n${state || ''}\n${country || ''}`

export const getSearchItemsResource = (
  auctionId: ?ID,
  charityId: ?ID
): string => {
  if (auctionId) {
    return `auction:${auctionId}:${domains.ITEMS}`
  } else if (charityId) {
    return `charity:${charityId}:${domains.ITEMS}`
  } else {
    return domains.ITEMS
  }
}

export const getSearchAuctionsResource = (charityId: ?ID): string => {
  if (charityId) {
    return `charity:${charityId}:${domains.AUCTIONS}`
  } else {
    return domains.AUCTIONS
  }
}

export function getImageSource(source: ?string): ?string {
  if (!!source && !/^http/.test(source)) {
    return `${window.location.origin}${MEDIA_URL}/${source}`
  }
  return source
}

export const scrollToTop = () => window.scrollTo(0, 0)

export const ascendingAuctionsByCloseTimeSorter = (
  a: Auction,
  b: Auction
): number => new Date(a.closeTime) - new Date(b.closeTime)

export const descendingAuctionsByCloseTimeSorter = (
  a: Auction,
  b: Auction
): number => new Date(b.closeTime) - new Date(a.closeTime)



// WEBPACK FOOTER //
// ./src/services/utils.js